function Section({title, subtitle, subtitleClassName, className, contentClassName, children}) {
	// Build class name
	let classList = ["section"];

	if (typeof className === "string") {
		classList.push(className);
	}

	// Build contentClassName
	let contentClassList = ["section-content"];

	if (typeof contentClassName === "string") {
		contentClassList.push(contentClassName);
	}

	// Subtitle
	const subtitleMarkup = typeof subtitle === "string" ? (<p className={subtitleClassName}>{subtitle}</p>) : null;

	return (
		<div className={classList.join(" ")}>
			<h3>{title}</h3>
			{subtitleMarkup}
			<div className={contentClassList.join(" ")}>{children}</div>
		</div>
	);
}

module.exports = Section;


// WEBPACK FOOTER //
// ./resources/js/components/forms/Section.js